<template>
  <div v-if="mixinEnvironnement_inEditor">
    <p v-if="content.idProduitCollection && produitCollection">
      Collection: {{ produitCollection.name }} ({{ produitCollection.titreCollectionFr }})
    </p>
    <p v-else>Liste unique de {{ content.listeIdProduit.length }} produit(s)</p>
  </div>
</template>

<script>
// Component vide pour afficher la barre d'édition dans Magnolia

import { mapGetters } from 'vuex';

import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'ProduitCollection',
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  computed: {
    ...mapGetters({
      getByUuid: 'produitCollection/getByUuid',
    }),
    produitCollection() {
      return this.getByUuid(this.content.idProduitCollection);
    },
  },
};
</script>
